<template>
    <svg v-if="paths[name]"
         :class="['component', 'icon', className]"
         :width="computedWidth"
         :height="computedHeight"
         :viewBox="viewBox"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         :role="roleToUse"
         :aria-label="!hidden && ariaLabel ? ariaLabel : undefined"
         :aria-hidden="hidden ? 'true' : undefined"
         :preserveAspectRatio="preserveAspectRatio">

        <path v-for="(path, index) in paths[name]"
              :key="index"
              :d="path"
              fill="currentColor"
              fill-rule="evenodd"
              clip-rule="evenodd" />
    </svg>
</template>

<script>
    const paths = {
        Search_24: [
            'M9.60352 4.68945C12.6411 4.68945 15.1035 7.15189 15.1035 10.1895C15.1035 13.227 12.6411 15.6895 9.60352 15.6895C6.56595 15.6895 4.10352 13.227 4.10352 10.1895C4.10352 7.15189 6.56595 4.68945 9.60352 4.68945ZM17.1035 10.1895C17.1035 6.04732 13.7457 2.68945 9.60352 2.68945C5.46138 2.68945 2.10352 6.04732 2.10352 10.1895C2.10352 14.3316 5.46138 17.6895 9.60352 17.6895C13.7457 17.6895 17.1035 14.3316 17.1035 10.1895Z',

            'M18.8828 20.8965L14.0898 16.1895H17.0898L20.297 19.4823L18.8828 20.8965Z'
        ],

        ArrowLeft_24: [
            'M10.828 5.636L4.464 12L10.828 18.364L12.242 16.95L8.293 13H20V11H8.293L12.242 7.05L10.828 5.636Z'
        ], 

        Close_16: [
            'M12.7071 4.70711L11.2929 3.29289L8 6.58579L4.70711 3.29289L3.29289 4.70711L6.58579 8L3.29289 11.2929L4.70711 12.7071L8 9.41421L11.2929 12.7071L12.7071 11.2929L9.41421 8L12.7071 4.70711Z'
        ],
        ArrowRight_16: [
            'M5.5 3L12.5 8L5.5 13V3Z',
        ],
        Close_24: [
            'M18.7071 7.70711L17.2929 6.29289L12 11.5858L6.70711 6.29289L5.29289 7.70711L10.5858 13L5.29289 18.2929L6.70711 19.7071L12 14.4142L17.2929 19.7071L18.7071 18.2929L13.4142 13L18.7071 7.70711Z',
        ],
    };

    export default {
        name: 'Icon',

        props: {
            className: {
                type: String,
                default: '',
            },

            height: {
                type: [Number, String],
                default: '',
            },

            hidden: {
                type: Boolean,
                default: false,
            },

            name: {
                type: String,
                required: true,
            },

            preserveAspectRatio: {
                type: String,
                default: 'xMidYMid meet',
            },

            role: {
                type: String,
                default: 'img',
            },

            size: {
                type: Number,
                default: 0,
            },

            ariaLabel: {
                type: String,
                default: '',
            },

            width: {
                type: [Number, String],
                default: '',
            },
        },

        computed: {
            paths() {
                return paths;
            },

            sizeFromName() {
                return Number(this.name?.split('_')?.[1]) || 24;
            },

            computedWidth() {
                return this.width || this.size || this.sizeFromName || 24;
            },

            computedHeight() {
                return this.height || this.size || this.sizeFromName || 24;
            },

            viewBox() {
                const size = this.sizeFromName;
                return `0 0 ${size} ${size}`;
            },

            roleToUse() {
                return this.hidden || !this.ariaLabel
                    ? 'presentation'
                    : this.role;
            },
        },
    };
</script>